/* eslint-disable */
import { createListenerMiddleware } from "@reduxjs/toolkit";

import { logout } from "../../store/authSlice";
import api from "../api";

const logoutListener = createListenerMiddleware();

logoutListener.startListening({
  actionCreator: logout,
  effect: async (_, listenerApi) => {
    // Can cancel other running instances
    listenerApi.cancelActiveListeners();

    listenerApi.dispatch(api.util.resetApiState());
  },
});

export default logoutListener;
